import React, { useState, useRef, useEffect } from 'react';
import { FileDown, Calendar, BarChart3 } from 'lucide-react';

const HoursExportDropdown = ({ 
  onExportSingleMonth, 
  onExportMultiMonth, 
  selectedMonth 
}) => {
  const [showOptions, setShowOptions] = useState(false);
  const dropdownRef = useRef(null);
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className="relative" ref={dropdownRef}>
      <button 
        onClick={() => setShowOptions(!showOptions)}
        className="inline-flex items-center gap-1 px-3 py-1.5 text-sm font-medium text-white bg-cyan-600 border border-transparent rounded-md hover:bg-cyan-700"
      >
        <FileDown className="h-4 w-4" />
        Print Options
        <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>
      
      {showOptions && (
        <div className="absolute right-0 mt-2 w-64 bg-white rounded-md shadow-lg border border-gray-200 z-50">
          <div className="py-1">
            <div className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-gray-100">
              Full Month Reports
            </div>
            <button
              onClick={() => {
                onExportSingleMonth();
                setShowOptions(false);
              }}
              className="flex items-center w-full px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              <Calendar className="h-4 w-4 mr-2" />
              <div className="text-left">
                <div className="font-medium">Full Month Detail</div>
                <div className="text-xs text-gray-500">24-hour grid for {selectedMonth.toLocaleDateString('en-GB', { month: 'long' })}</div>
              </div>
            </button>
            
            <div className="px-3 py-2 text-xs font-medium text-gray-500 uppercase tracking-wider border-b border-t border-gray-100">
              Multi-Month Summary
            </div>
            <button
              onClick={() => {
                onExportMultiMonth(3);
                setShowOptions(false);
              }}
              className="flex items-center w-full px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              <BarChart3 className="h-4 w-4 mr-2" />
              <div className="text-left">
                <div className="font-medium">3-Month Summary</div>
                <div className="text-xs text-gray-500">Chart view with compliance overview</div>
              </div>
            </button>
            <button
              onClick={() => {
                onExportMultiMonth(6);
                setShowOptions(false);
              }}
              className="flex items-center w-full px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              <BarChart3 className="h-4 w-4 mr-2" />
              <div className="text-left">
                <div className="font-medium">6-Month Summary</div>
                <div className="text-xs text-gray-500">Chart view with compliance overview</div>
              </div>
            </button>
            <button
              onClick={() => {
                onExportMultiMonth(12);
                setShowOptions(false);
              }}
              className="flex items-center w-full px-3 py-2 text-sm text-gray-700 hover:bg-gray-50"
            >
              <BarChart3 className="h-4 w-4 mr-2" />
              <div className="text-left">
                <div className="font-medium">12-Month Summary</div>
                <div className="text-xs text-gray-500">Annual chart view with compliance overview</div>
              </div>
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default HoursExportDropdown;